import classNames from 'classnames'
import React, { useContext } from 'react'
import { ChatContext } from '~/service/chatConn'
import ActiveChat from './activeChat'
import List from './List'
import HistoryList from './HistoryList'
import { ButtonGroup } from '~/components/common/bulma/Button'
import { NavLink, Route, Switch, useRouteMatch } from 'react-router-dom'
import HistoryShow from './HistoryShow'
import { FormattedMessage } from '~/translations/utils'
import Search from '~/components/common/Search'
import { ChatHistoryManagerContext } from '~/service/ChatHistoryManager'
import useResizeObserver from 'use-resize-observer'

const Chat: React.FC = ({}) => {
  const { activeChatMaybe, unread } = useContext(ChatContext)
  const { filter, setFilter, search, setSearch } = useContext(
    ChatHistoryManagerContext
  )
  const { path } = useRouteMatch()
  const chatShow = useRouteMatch('/chat/history/:chatId')
  const chatList = useRouteMatch('/chat/history')
  const { ref, width = 0 } = useResizeObserver<HTMLElement>()

  // jakoś tutaj przywrócić, albo css-em albo js-em, wybór czy ma się
  // wyświetlać to czy to na mobilnym

  return (
    // <div className="chat">{activeChatMaybe ? <ActiveChat /> : <List />}</div>
    <>
      <div className="main-header list-header" ref={ref}>
        {window.c.chatHistory && (
          <>
            {chatList && (
              <Search
                filter={filter}
                setFilter={setFilter}
                search={search}
                setSearch={setSearch}
                small={width > 1200}
              />
            )}
            <div className="list-filter list-filter--top">
              <ButtonGroup>
                <NavLink
                  exact
                  to={path + '/'}
                  activeClassName="is-active is-info"
                  className="button is-small"
                >
                  {typeof unread != 'undefined' && unread > 0 && (
                    <div className="button-badge">{unread}</div>
                  )}
                  <FormattedMessage id="chat / active / title" />
                </NavLink>
                <NavLink
                  to={path + '/history'}
                  activeClassName="is-active is-info"
                  className="button is-small"
                >
                  <FormattedMessage id="chat / history / title" />
                </NavLink>
              </ButtonGroup>
            </div>
          </>
        )}
      </div>
      <Switch>
        <Route path={path + '/history'}>
          <div
            className={classNames('chat chat-history', {
              'is-any-active': chatShow,
            })}
          >
            <HistoryList />
            <Route path={path + '/history/:chatId'}>
              <div className="chat-activeChat">
                <HistoryShow />
              </div>
            </Route>
            {!chatShow && (
              <div className="chat-empty">
                <span className="fat fa-messages" />
              </div>
            )}
          </div>
        </Route>
        <Route path={path + '/'}>
          <div
            className={classNames('chat', { 'is-any-active': activeChatMaybe })}
          >
            {/* {!chats.length ? (
              <div className="notification">
                {intl.formatMessage({ id: 'chat / list / empty' })}
              </div>
            ) : ( */}
            <>
              <List />

              {activeChatMaybe ? (
                <ActiveChat key={activeChatMaybe.id} />
              ) : (
                <div className="chat-empty">
                  <span className="fat fa-messages" />
                </div>
              )}
            </>
            {/* )} */}
          </div>
        </Route>
      </Switch>
    </>
  )
}

export default Chat
